import React, { useEffect }  from "react";
import { connect } from "react-redux";
import ClientUserTable from "./components/ClientUserTable";


const ClientUsers = ({clientId}) => {
	
	useEffect(() => {
	}, [clientId]);

	return (
		
	    <div>
			<ClientUserTable clientId={clientId} />
	    </div>
    );
};

const mapStateToProps = (state) => ({
  	  
});

const mapDispatchToProps = (dispatch) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(ClientUsers);